import { render, staticRenderFns } from "./AccountTransactionForm.vue?vue&type=template&id=bb8bcfe8"
import script from "./AccountTransactionForm.vue?vue&type=script&lang=js"
export * from "./AccountTransactionForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports